import React, { Fragment, useState  } from 'react';
import { Grid, Typography } from '@material-ui/core';
import UpdateCancel from '../../atoms/buttons/UpdateCancel';


export function ChangeDelegateType(props) {
    const { onClose,invokeEditDelegateApi } = props;
    const [isUpdating, setIsUpdating] = useState(false);
    const onUpdate = () => {
        setIsUpdating(true);
        invokeEditDelegateApi(true);
    }

    return (
        <Grid container direction={"row"} spacing={3} >
            <Grid item xs={12}>
                <Fragment>
                    <Typography>The routing rules associated with this delegate will be no longer valid.</Typography>
                    <Typography>Are you sure to make changes ?  </Typography>
                </Fragment>
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <UpdateCancel onUpdate={onUpdate} onCancel={onClose} content={isUpdating ? 'Updating..' : 'Update'} updateDisable={isUpdating} typesNotIn={['transaction', 'view']}/>
            </Grid>
        </Grid>
    )
}